<template>
  <v-row
    text-align='center'
    justify='center'
    no-gutters
  >
    <v-col class='pa-0'>
      <my-lists ref='myLists' :user='user' :xp='xp' />
      <v-list-item three-line class='ambia-ua-list-item align-start pr-0 pt-4' style='min-height:140px'>
        <v-list-item-action class='ambia-ua-list-item-action'>
          <v-dialog v-model='dialog' scrollable max-width='300px'>
            <template v-slot:activator='{ on }'>
              <v-btn icon color='#0f505f' dark v-on='on'>
                <v-icon class='ambia-copy' dark>
                  {{ mdiPlus }}
                </v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title>Incluir na lista de...</v-card-title>
              <v-divider />
              <v-card-text style='height: 300px;'>
                <v-container fluid>
                  <template v-for='(lists, index) in user.lists'>
                    <v-checkbox :key='index' v-model='lists.experiences' :value='xp.id' :label='lists.name' @change='$refs.myLists.updateList(index, lists.name)' />
                  </template>
                </v-container>
              </v-card-text>
              <v-btn v-if='createNewListBtn' v-model='createNewListBtn' size='0' text @click='createNewListBtn=false'>
                <v-icon>
                  {{ mdiPlus }}
                </v-icon>
                Criar Nova Lista
              </v-btn>
              <v-divider />
              <v-text-field v-if='!createNewListBtn' v-model='listName' class='pa-2' label='Insira o nome da lista...' @keyup.enter='createNewListBtn=true;$refs.myLists.createUserList(listName);clearTextField()' />
            </v-card>
          </v-dialog>
          <!-- TODO: we actually need to place the download icon, directing the user to download
          labs just like in my-lists component -->
          <share v-if='type !== "labs"'
                 :id-experience='getId(type, xp)'
                 :email='user.email'
                 :experience-type='type'
                 :role='user.role'
          />
          <div v-if='type === "labs"'>
            <v-btn
              v-if='isUserAuthorized()'
              icon
              :href='getInstallerUrl'
            >
              <v-icon dark>
                {{ mdiDownload }}
              </v-icon>
            </v-btn>
            <v-btn
              v-else
              icon
              @click='downloadMessage()'
            >
              <v-icon dark>
                {{ mdiDownload }}
              </v-icon>
            </v-btn>
          </div>
        </v-list-item-action>

        <v-list-item-content class='pt-0'>
          <v-list-item-title>
            <overlay-video v-if='type === "360"' :title='xp.title' :src='contentUrl' />
            <v-list-item-title v-if='type === "3d"' class='ambia-vr-list-item-title'>
              <overlay-model :id='xp.id' :title='xp.title' />
            </v-list-item-title>
            <overlay-video v-if='type === "labs"' :ime-player='false' :title='xp.title' :src='contentUrl' />
          </v-list-item-title>
          <v-list-item-subtitle class='pt-2 text--primary'>
            {{ xp.course }}
            <span class='ambia-ua-blank'>.</span>
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            Código da Experiência: {{ xp.code }}
          </v-list-item-subtitle>
          <v-row v-if='xp.description'>
            <v-col cols='12' class='d-inline-flex align-start'>
              <div v-if='type != "3d"'>
                <div v-if='xp.description.length < 350' class='ambia-item-objectives-item'>
                  {{ xp.description }}
                </div>
                <div v-else class='ambia-item-objectives-item'>
                  {{ xp.description.substring(0,i) + dots }} <a @click='showFullDescription()'>{{ readMoreText }}</a>
                </div>
              </div>
              <div v-else>
                <div v-if='posterUrl'>
                  <v-img
                    :src='posterUrl'
                    max-height='256'
                    max-width='256'
                  />
                </div>
                <div v-else class='ambia-item-objectives-item'>
                  {{ xp.description }}
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols='12' class='d-inline-flex align-start'>
              <div v-if='type != "3d"'>
                <span class='ambia-ua-blank'><br>.</span>
              </div>
            </v-col>
          </v-row>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
    </v-col>
  </v-row>
</template>

<script>
  import { mdiPlus, mdiMinus, mdiDownload } from '@mdi/js'
  import Const from '@/helpers/const'
  import MyLists from '@/components/MyLists'
  export default {
    name: 'Experience',
    components: {
      'myLists': MyLists
    },
    props: {
      xp: {
        type: Object,
        default: new Object()
      },
      type: {
        type: String,
        default: ''
      },
      user: {
        type: Object,
        default: new Object()
      }
    },
    data () {
      return {
        i: 300,
        readMoreText: 'Ler mais',
        dots: '...',
        mdiPlus, mdiMinus, mdiDownload,
        dialog: false,
        createNewListBtn: true,
        textField: false,
        listName:'',
      }
    },
    computed: {
      contentUrl() {
        // Return the URL of the first content inside the Learning Object
        return this.getFirstContent(this.xp).url || ''
      },
      posterUrl() {
        // Return the poster URL of the first content inside the Learning Object
        return this.getFirstContent(this.xp).posterUrl || ''
      },
      getInstallerUrl () {
        // Returns ambia's installer link to the authorized user
        return Const.AWS_CONFIG().ambiaInstallerUrl
      },
    },
    methods: {
      showFullDescription() {
        if (this.i == 300){
          this.i = 9999
          this.readMoreText = 'Ocultar'
          this.dots = ''
        } else {
          this.i = 300
          this.readMoreText = 'Ler Mais'
          this.dots = '...'
        }
      },
      clearTextField() {
        this.listName = ''
      },

      getId(type, xp) {
        if (type === '360')
          return this.getVideoId(xp)
        else
          return xp.id
      },

      getVideoId(xp) {
        try {
          // Return the URL of the first content inside the Learning Object
          let firstContentId = xp.sortedContentIds[0]
          let firstContent = xp.contents.items.find(item =>
            item.id === firstContentId
          )
          let url = firstContent.content.url
          if (url.indexOf('/') >= 0)
            return url.split('/').pop() || ''
          return ''
        } catch (error) {
          console.error(error)
          return ''
        }
      },

      getFirstContent(xp) {
        try {
          let firstContentId = xp.sortedContentIds[0]
          let firstContent = xp.contents.items.find(item =>
            item.id === firstContentId
          )
          if (!firstContent && xp.contents.items.length)
            return xp.contents.items[0].content
          return firstContent.content
        } catch (error) {
          console.error(error)
          return null
        }
      },

      downloadMessage() {
        let text = 'Por favor, envie um email para contato@imersys.com para ter acesso'
        this.$toasted.clear()
        this.$toasted.show(text, this.toastOptions)
      },

      isUserAuthorized () {
        // By default we prohibit 'democatalogo' user (the "salesman user") to
        // fetch the keys to be used within the LMS. This is an workaround scheme
        // for authorization.
        return this.user.email !== 'democatalogo@imersys.com' && this.user.displayName !== 'democatalogo'
          && this.user.role !== 'guest'
      },
    }
  }

</script>
<style lang="scss" scoped>
.ambia-ua-list-item{
  padding-left: 0px;
}

.ambia-ua-list-item-action{
  margin-top: -6px;
  margin-right: 6px !important;
  @media only screen and (max-width: 800px) {
    margin-top: -8px;
  }
}

.ambia-ua-blank{
  color: white;
}
</style>
